import { render, staticRenderFns } from "./search-catalog.vue?vue&type=template&id=8e56038a&"
import script from "./search-catalog.vue?vue&type=script&lang=js&"
export * from "./search-catalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports